// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Element)

// 引入编辑器
import Tinymce from 'tinymce'

Vue.prototype.$tinymce = Tinymce;

import Vue from 'vue'
import App from './App'
import router from './router'

import xmJs from '../static/js/XmUtils.js';
import https from '../static/js/https.js';
import global from '../static/js/global.js';
import Store from './store/index.js';


import axios from 'axios';

import 'lib-flexible';


import less from 'less'

Vue.use(less)

import vueEsign from 'vue-esign'

Vue.use(vueEsign)

import Astrict from './utils/astrict.js'

Vue.use(Astrict)

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

Vue.use(VueVideoPlayer)


import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor);

Vue.config.productionTip = false;
Vue.prototype.$global = global;
Vue.prototype.$store = Store;
Vue.prototype.$axios = axios;
Vue.prototype.api = https;
Vue.prototype.xm = xmJs;


router.beforeEach((to, from, next) => {
    const role = localStorage.getItem('user_token');
    if (to.matched.some(record => record.meta.requireAuth)) {

        if (role) {

            next();

        } else {
            Element.Message.error('请先登录');
            next({
                path: '/login'
                // query: {
                //   redirect: to.fullPath
                // }
            })
        }

    } else {
        next();

    }

});


var vue = new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    Store,
    template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js